import { useWindowSize as l } from "../context/WindowSize/WindowDimensionsProvider.js";
import "../context/WindowSize/Dimensions.js";
import { maxPhoneWidth as s, maxTabletWidth as n } from "../utils/css/mediaQueries.js";
function m() {
  const { width: t } = l(), e = t <= s, o = t > s && t <= n, i = t > n;
  return {
    isMobileOnly: e,
    isTabletOnly: o,
    isDesktopOnly: i,
    isMobileOrTablet: e || o,
    isTabletOrDesktop: o || i
  };
}
export {
  m as default
};
